import { z } from 'zod';

/**
 * Standardized API Response Schemas
 */

export const ApiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.string(), z.unknown()).optional(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

export const ApiSuccessResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  z.object({
    success: z.literal(true),
    data: dataSchema,
    meta: z.object({
      requestId: z.string().uuid(),
      timestamp: z.string().datetime(),
    }),
  });

export const ApiErrorResponseSchema = z.object({
  success: z.literal(false),
  error: ApiErrorSchema,
  meta: z.object({
    requestId: z.string().uuid(),
    timestamp: z.string().datetime(),
  }),
});
export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>;

// Generic response type helper
export type ApiResponse<T> =
  | { success: true; data: T; meta: { requestId: string; timestamp: string } }
  | ApiErrorResponse;

export const HealthCheckResponseSchema = z.object({
  status: z.enum(['healthy', 'degraded', 'unhealthy']),
  version: z.string(),
  uptime: z.number(),
  checks: z.record(z.string(), z.object({
    status: z.enum(['pass', 'fail']),
    message: z.string().optional(),
  })),
});
export type HealthCheckResponse = z.infer<typeof HealthCheckResponseSchema>;
